module.exports = __webpack_public_path__ + "img/image.ab9bba61.png";